import {Theme} from './theme'
import {useCurrentTheme} from './useCurrentTheme'

export default function useContentLoaderColors() {
  const [currentTheme] = useCurrentTheme()

  return (() => {
    if (currentTheme === Theme.Light) return ['#f3f3f3', '#ecebeb'] as const
    return ['#1f2024', '#27282d'] as const
  })()
}
